import CampaignStatusListing from '@/Component/Brand/MyCampaigns/CampaignListing/CampaignStatusListing'

const CampaignListingPage = () => {
  return (
    <CampaignStatusListing />
  )
}
export default CampaignListingPage
